import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BaseSearchForm } from '@shared/ui/base-search-form';
import { UiGroupControl } from '@shared/ui/controls/ui-group-control.model';
import { ViewControl } from '@shared/ui/controls/view-control.model';
import { UiColumn } from '@shared/ui/ui-column';
import { TextAreaControl } from '@shared/ui/controls/textarea-control.model';
import { ViewRowControl } from '@shared/ui/controls/view-row-control.model';
import { ToggleControl } from '../../../shared/ui/controls/toggle-control.model';
import { TextControl } from '../../../shared/ui/controls/text-control.model';
import { ItemSearchResult } from '@shared/interfaces/gridrows/item-search-result.interface';
import { SearchGridComponent } from '../../../shared/components/grid/search-grid.component';
import { ToolBarComponent } from '@progress/kendo-angular-toolbar';
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { SecurityRole } from '../../../shared/literals/shared.literal';
import { OrganizationSelect } from '../../../shared/ui/select-controls/organizations-select.model';
import { VisibleProperty } from '../../../shared/ui/control-options/control-option.interface';
import { SecurityRoleSearchResult } from '../../../shared/interfaces/gridrows/security-role-result.interface';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-security-role-list',
    templateUrl: './security-role-list.component.html',
    styleUrls: ['./security-role-list.component.css'],
    standalone: false
})
export class SecurityRoleListComponent extends BaseSearchForm<SecurityRoleSearchResult> implements OnInit {

  @ViewChild('toolbar') bar: ToolBarComponent;

  organizationId: Number | null;

  @Input() items: ToolbarItem[];

  ngOnInit(): void {

    var session = this.auth.getSession();

    this.organizationId = Number(session?.organizationId);

    var toolbarAddNew: ToolbarItem = {
      text: 'Add Security Role',
      icon: faPlus,
      hasMultiple: false,
      cssClass: 'success',
      action: () => { this.redirectToNewSecurityRole(); }
    };


    this.toolbarItems.unshift(toolbarAddNew);
  }

  preSave(formControls: { [k: string]: FormControl }): void {

    var organizationid = this.auth.getOrganizationId();

    formControls['organizationid'] = new FormControl(organizationid);
  }
  constructor(private router: Router, private auth: AuthenticationService) {
    super();
    this.name = "SecurityRole";
    this.apiController = "SecurityRole";
    this.keyFieldName = "id";
    this.canFilterSearch = this.auth.isAdmin();

    this.initializeUiControls();
    this.setGridSettings();
  }
  override initializeUiControls() {

    const view = new ViewControl("");

    const search = new UiGroupControl("", "Search");

    const isActive = new ToggleControl("isActive", "Is Active?", true);

    var row = new ViewRowControl();
    row.controls.push(isActive);

    search.rows.push(row);
    view.controls.push(search);

    this.views.push(view);
  }

  setGridSettings(): void {
    this.gridSettings = {
      gridName: "SecurityRoleSearch_Grid",
      showSubGrid: false,
      preloadData: true,
      columns: this.getColumns()
    };
  }

  private getColumns(): UiColumn[] {
    let cols: UiColumn[] = [];

    var name = new UiColumn("name", "Role", 100);
    var isActive = new UiColumn("isActive", "Is Active?", 100, true, "boolean");

    cols.push(name, isActive);

    return cols;
  }

  public redirectToNewSecurityRole() {
    this.router.navigate(['/SecurityRole/Detail/0']);
  }
}
